// extracted by mini-css-extract-plugin
module.exports = {"UploadAndDisplay":"UploadAndDisplay--uploadAndDisplay--2VrL7NA"};